import React from 'react';
import Icon from '../../../components/AppIcon';

const SignupCompletionPanel = ({ metrics, loading }) => {
  if (loading) {
    return (
      <div className="bg-card rounded-xl border border-border p-6">
        <div className="animate-pulse">
          <div className="h-6 bg-gray-200 rounded w-1/3 mb-4" />
          <div className="space-y-3">
            <div className="h-24 bg-gray-200 rounded" />
            <div className="h-16 bg-gray-200 rounded" />
          </div>
        </div>
      </div>
    );
  }

  const completionRate = metrics?.completionRate || 0;
  const isHealthy = completionRate >= 80;

  return (
    <div className="bg-card rounded-xl border border-border p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-lg font-heading font-semibold text-foreground flex items-center gap-2">
          <Icon name="UserCheck" size={20} strokeWidth={2} />
          Signup Completion
        </h2>
        <div className={`px-3 py-1 rounded-full text-sm font-medium ${
          isHealthy 
            ? 'bg-green-50 text-green-700 border border-green-200' :'bg-red-50 text-red-700 border border-red-200'
        }`}>
          {isHealthy ? 'Healthy' : 'Needs Attention'}
        </div>
      </div>

      {/* Completion Rate Circle */}
      <div className="flex items-center justify-center mb-6">
        <div className="relative w-40 h-40">
          <svg className="transform -rotate-90 w-40 h-40">
            <circle
              cx="80"
              cy="80"
              r="70"
              stroke="#e5e7eb"
              strokeWidth="12"
              fill="none"
            />
            <circle
              cx="80"
              cy="80"
              r="70"
              stroke={isHealthy ? '#10b981' : '#ef4444'}
              strokeWidth="12"
              fill="none"
              strokeDasharray={`${(completionRate / 100) * 439.6} 439.6`}
              strokeLinecap="round"
            />
          </svg>
          <div className="absolute inset-0 flex flex-col items-center justify-center">
            <span className="text-4xl font-bold text-foreground">
              {completionRate}%
            </span>
            <span className="text-sm text-muted-foreground">Complete</span>
          </div>
        </div>
      </div>

      {/* Metrics Grid */}
      <div className="grid grid-cols-3 gap-4">
        <div className="text-center">
          <p className="text-2xl font-bold text-foreground">
            {metrics?.totalSignups || 0}
          </p>
          <p className="text-xs text-muted-foreground mt-1">Total Signups</p>
        </div>
        <div className="text-center">
          <p className="text-2xl font-bold text-green-600">
            {metrics?.completedSignups || 0}
          </p>
          <p className="text-xs text-muted-foreground mt-1">Completed</p>
        </div>
        <div className="text-center">
          <p className="text-2xl font-bold text-orange-600">
            {metrics?.pendingVerifications || 0}
          </p>
          <p className="text-xs text-muted-foreground mt-1">Pending</p>
        </div>
      </div>

      {/* Advice for pending verifications */}
      {metrics?.pendingVerifications > 0 && (
        <div className="mt-4 p-3 bg-blue-50 border border-blue-200 rounded-lg">
          <div className="flex items-start gap-2">
            <Icon name="Info" size={16} strokeWidth={2} className="text-blue-600 flex-shrink-0 mt-0.5" />
            <div className="text-sm text-blue-800">
              <p className="font-semibold mb-1">Email Verification Guidance</p>
              <p className="text-xs">
                Users should check their inbox first (emails may take 1-2 minutes). 
                If not received after 5 minutes, they can resend using the same email address.
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SignupCompletionPanel;